import { IPostState, IGetPostArgs, IGetPostPayload } from '../types';
import { GET_POSTS } from '../constants';
import postServices from '../postServices';
import { createAsyncThunk, ActionReducerMapBuilder } from '@reduxjs/toolkit';

export const getPosts = createAsyncThunk<
  IGetPostPayload,
  IGetPostArgs,
  ThunkAPIConfig
>(GET_POSTS, async (args, { rejectWithValue }) => {
  try {
    const params = {
      ...args,
      page: args?.page || 1,
      limit: args?.limit || 5,
      content: args.content ? args.content : undefined,
      petType: args.petType ? args.petType : undefined,
      postTypes: 'NORMAL,LETTER_HEAVEN'
    };

    const { data } = await postServices.getPostList(params);
    const { result, metaData } = data.data;

    return {
      data: result,
      pagination: metaData
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getPostsBuilder = (
  builder: ActionReducerMapBuilder<IPostState>
) => {
  const { pending, fulfilled, rejected } = getPosts;
  builder
    .addCase(pending, draftState => {
      draftState.loading = true;
    })
    .addCase(fulfilled, (draftState, action) => {
      const { data, pagination } = action.payload;
      draftState.loading = false;
      draftState.postData = data;
      draftState.pagination = pagination;
    })
    .addCase(rejected, draftState => {
      draftState.loading = false;
    });
};
